export default __webpack_public_path__ + "static/media/hydrogen.676958c6.svg";